<div class="amortization-plan-payment-notice-sidebar astral-sidebar-shell">
  <div class="astral-sidebar-content astral-stack-l">
    <h2 class="astral-sidebar-heading">{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.TITLE' | translate }}</h2>
    <app-information-block [text]="'AMORTIZATION_PLAN.PAYMENT_NOTICE.DESCRIPTION' | translate"></app-information-block>

    @if (isLoading) {
      <div class="loading-text">{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.LOADING' | translate }}</div>
    }

    <form class="astral-stack-l" [formGroup]="form" (ngSubmit)="submit()">
      <section class="astral-section-surface astral-section-surface--compact">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <app-month-year-select [control]="form.controls['dueFrom']" [itemsSource]="periodSelection"></app-month-year-select>
          <app-month-year-select [control]="form.controls['dueTo']" [itemsSource]="periodSelection"></app-month-year-select>
        </astral-layout-group>
      </section>

      <div class="astral-form-actions">
        <astral-button
          variant="secondary"
          type="button"
          (click)="previewPaymentNotices()"
          [disabled]="!canPreview"
          labelKey="AMORTIZATION_PLAN.PAYMENT_NOTICE.PREVIEW_ACTION"
        ></astral-button>
      </div>

      @if (hasInvalidPeriod) {
        <div class="invoice-excluded-message">
          {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.INVALID_PERIOD' | translate }}
        </div>
      }

      @if (previewLoaded) {
        <div class="section">
          <div class="section-title">
            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.MANUAL_NOTICE_LIST' | translate }} ({{ preview?.manualNoticeInstallments?.length || 0 }})
          </div>
          <div class="section-description">
            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.MANUAL_NOTICE_LIST_DESCRIPTION' | translate }}
          </div>
          @if (!(preview?.manualNoticeInstallments?.length)) {
            <div class="empty-state">
              {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.NO_MANUAL_NOTICE_INSTALLMENTS' | translate }}
            </div>
          }
          @if (preview?.manualNoticeInstallments?.length) {
            <div class="invoice-table">
              <div class="invoice-row invoice-row-header preview-grid">
                <span>{{ 'COMMON.CONTACT' | translate }}</span>
                <span>{{ 'COMMON.COMPANY' | translate }}</span>
                <span>{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENT_DUE_DATE' | translate }}</span>
                <span>{{ 'COMMON.AMOUNT' | translate }}</span>
                <span>{{ 'COMMON.DESCRIPTION' | translate }}</span>
              </div>
              @for (item of preview?.manualNoticeInstallments; track item) {
                <div class="invoice-row preview-grid">
                  <span>{{ item.debtorContactName }}</span>
                  <span>{{ item.companyName }}</span>
                  <span>{{ item.dueDate?.toLocaleDateString() }}</span>
                  <span>{{ item.amount?.toString() }}</span>
                  <span>{{ item.description }}</span>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (previewLoaded && hasRentInvoiceInstallments) {
        <div class="section">
          <div class="section-title">
            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.RENT_INVOICE_LIST' | translate }} ({{ preview?.rentInvoiceInstallments?.length || 0 }})
          </div>
          <div class="section-description">
            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.RENT_INVOICE_LIST_DESCRIPTION' | translate }}
          </div>
          <div class="invoice-table">
            <div class="invoice-row invoice-row-header rent-invoice-grid">
              <span>{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.FORCE_SEPARATE_NOTICE' | translate }}</span>
              <span>{{ 'COMMON.CONTACT' | translate }}</span>
              <span>{{ 'COMMON.COMPANY' | translate }}</span>
              <span>{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENT_DUE_DATE' | translate }}</span>
              <span>{{ 'COMMON.AMOUNT' | translate }}</span>
              <span>{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.RENT_INVOICE_INFO' | translate }}</span>
            </div>
            @for (item of preview?.rentInvoiceInstallments; track item) {
              <div class="invoice-row rent-invoice-grid">
                <span class="checkbox-cell">
                  <mat-checkbox
                    [checked]="item.manualOverrideSelected"
                    [disabled]="!item.canForceManual"
                    (change)="onManualOverrideChanged(item, $event.checked)"
                  ></mat-checkbox>
                </span>
                <span>{{ item.debtorContactName }}</span>
                <span>{{ item.companyName }}</span>
                <span>{{ item.dueDate?.toLocaleDateString() }}</span>
                <span>{{ item.amount?.toString() }}</span>
                <span>
                  @if (item.matchingLeaseAgreementNumber) {
                    <div>
                      {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.LEASE_AGREEMENT' | translate }}: {{ item.matchingLeaseAgreementNumber }}
                    </div>
                  }
                  @if (item.matchingRentPeriodText) {
                    <div>
                      {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.RENT_PERIOD' | translate }}: {{ item.matchingRentPeriodText }}
                    </div>
                  }
                  @if (!item.canForceManual) {
                    <div class="invoice-excluded-message">
                      {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.MANUAL_OVERRIDE_DISABLED' | translate }}
                    </div>
                  }
                </span>
              </div>
            }
          </div>
        </div>
      }

      @if (previewLoaded && hasExcludedItems) {
        <div class="section">
          <div class="section-title">
            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.EXCLUDED' | translate }} ({{ preview?.excludedItems?.length || 0 }})
          </div>
          <div class="invoice-table">
            <div class="invoice-row invoice-row-header excluded-grid">
              <span>{{ 'COMMON.CONTACT' | translate }}</span>
              <span>{{ 'COMMON.COMPANY' | translate }}</span>
              <span>{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENT_DUE_DATE' | translate }}</span>
              <span>{{ 'COMMON.AMOUNT' | translate }}</span>
              <span>{{ 'COMMON.STATUS' | translate }}</span>
            </div>
            @for (item of preview?.excludedItems; track item) {
              <div class="invoice-row excluded-grid">
                <span>{{ item.debtorContactName || '-' }}</span>
                <span>{{ item.companyName || '-' }}</span>
                <span>{{ item.dueDate?.toLocaleDateString() || '-' }}</span>
                <span>{{ item.amount?.toString() || '-' }}</span>
                <span class="invoice-excluded-message">{{ item.reason }}</span>
              </div>
            }
          </div>
        </div>
      }

      <div class="astral-form-actions">
        <astral-button variant="primary" type="submit" [disabled]="!canCreate" labelKey="CREATE_BTN"></astral-button>
        <astral-button variant="secondary" type="button" (click)="cancel()" [disabled]="isSaving" labelKey="CANCEL_BTN"></astral-button>
      </div>
    </form>
  </div>
</div>
